import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@common/utils/api';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade, Keyboard, Navigation, Pagination, Autoplay } from 'swiper';
import Lazyimg from '@components/utils/Lazyimg';
import ThronVideo from '@components/utils/ThronVideo';
import { debounce } from '@utils/functions';
import '@moncler/scss/components/hero-carousel-simplified/component-hero-carousel-simplified.scss';
import AOS from 'aos';
import HeroCarouselContentSlide from './HeroCarouselContentSlide';
SwiperCore.use([Pagination, EffectFade, Keyboard, Autoplay]);
const HeroCarousel = (props) => {
    const { t } = useTranslation();
    const [componentData, setComponentData] = useState(null);
    const [isCarousel, setIsCarousel] = useState(null);
    const [slides, setSlides] = useState(null);
    const [pause, setPause] = useState(false);
    const [mute, setMute] = useState(true);
    const heroCarouselRef = useRef(null);
    const imageCarouselRef = useRef();
    const contentCarouselRef = useRef();
    AOS.init();
    useEffect(() => {
        var _a;
        const pageID = props.pageId || ((_a = document.body.id) === null || _a === void 0 ? void 0 : _a.replace('page-', ''));
        if (pageID) {
            api.getPageJson(pageID, true).then((data) => {
                var _a;
                const componentDataRes = (_a = data.regions) === null || _a === void 0 ? void 0 : _a.flatMap((r) => r.components).find((c) => (c === null || c === void 0 ? void 0 : c.id) === props.uuid);
                setComponentData(componentDataRes);
                setSlides(componentDataRes === null || componentDataRes === void 0 ? void 0 : componentDataRes.regions[0].components);
            });
        }
    }, []);
    useEffect(() => {
        setIsCarousel((slides === null || slides === void 0 ? void 0 : slides.length) > 1);
        // console.log('slides:', slides);
        if ((slides === null || slides === void 0 ? void 0 : slides.length) > 0) {
            slides.forEach((s) => {
                window.editorialComponents = Object.assign(Object.assign({}, window.editorialComponents), { [s.id]: {
                        promoImpression: {
                            id: 'hero_image',
                            name: s.data.title_analytics || s.data.title,
                            creative: s.type,
                        },
                        bannerContainerID: props.uuid,
                    } });
            });
            document.querySelector('[data-uuid="' + props.uuid + '"]').style = '';
        }
    }, [slides]);
    useEffect(() => {
        var _a, _b, _c, _d;
        console.log('contentCarouselRef.current:', contentCarouselRef.current);
        if (heroCarouselRef.current) {
            if (pause) {
                heroCarouselRef.current.querySelector('[data-pause]').setAttribute('aria-pressed', 'true');
                (_a = contentCarouselRef.current.autoplay) === null || _a === void 0 ? void 0 : _a.stop();
                contentCarouselRef.current.el.closest('.hero-carousel__content-carousel').classList.remove('swiper-autoplay');
                (_b = imageCarouselRef.current.el.querySelectorAll('video')) === null || _b === void 0 ? void 0 : _b.forEach((v) => v.pause());
            }
            else {
                heroCarouselRef.current.querySelector('[data-pause]').setAttribute('aria-pressed', 'false');
                contentCarouselRef.current.params.autoplay = { delay: 5800 };
                (_c = contentCarouselRef.current.autoplay) === null || _c === void 0 ? void 0 : _c.start();
                contentCarouselRef.current.el.closest('.hero-carousel__content-carousel').classList.add('swiper-autoplay');
                (_d = imageCarouselRef.current.el.querySelectorAll('video')) === null || _d === void 0 ? void 0 : _d.forEach((v) => v.play());
            }
        }
    }, [pause]);
    useEffect(() => {
        if (heroCarouselRef.current) {
            if (!mute) {
                console.log('attivare il volume');
                let video = imageCarouselRef.current.el.querySelector('.swiper-slide-active video');
                if (video) {
                    video.muted = false;
                    video.setVolume(1);
                }
            }
            else {
                console.log('disattivare il volume');
                let video = imageCarouselRef.current.el.querySelector('.swiper-slide-active video');
                if (video) {
                    video.muted = true;
                    video.setVolume(0);
                }
            }
        }
    }, [mute]);
    if (!componentData || !slides) {
        return React.createElement(React.Fragment, null);
    }
    const beforeResize = () => {
        var _a, _b;
        (_a = imageCarouselRef === null || imageCarouselRef === void 0 ? void 0 : imageCarouselRef.current) === null || _a === void 0 ? void 0 : _a.el.closest('.hero-carousel__image-carousel').classList.add('resizing');
        (_b = contentCarouselRef === null || contentCarouselRef === void 0 ? void 0 : contentCarouselRef.current) === null || _b === void 0 ? void 0 : _b.el.closest('.hero-carousel__content-carousel').classList.add('resizing');
    };
    const onResize = () => {
        var _a;
        (_a = imageCarouselRef === null || imageCarouselRef === void 0 ? void 0 : imageCarouselRef.current) === null || _a === void 0 ? void 0 : _a.el.closest('.hero-carousel__image-carousel').classList.remove('resizing');
        contentCarouselRef === null || contentCarouselRef === void 0 ? void 0 : contentCarouselRef.current.el.closest('.hero-carousel__content-carousel').classList.remove('resizing');
    };
    const singleSlideWrapper = (contentType) => {
        const isTypeImage = contentType === 'image';
        return (React.createElement("div", { className: `${isTypeImage ? 'hero-carousel__slider' : 'hero-carousel__slider-content'} swiper-wrapper` },
            React.createElement("div", { className: "swiper-wrapper" }, isTypeImage ? imageSlides() : contentSlides())));
    };
    const renderSwiper = (options, renderSlides) => {
        return (React.createElement(Swiper, Object.assign({ rewind: true, speed: 800, effect: "fade", fadeEffect: { crossFade: true }, mousewheel: { forceToAxis: true, thresholdDelta: 20 }, a11y: {
                enabled: true,
                slideRole: 'group',
                itemRoleDescriptionMessage: 'slide',
                prevSlideMessage: t('carousel.prevslidemessage'),
                nextSlideMessage: t('carousel.nextslidemessage'),
                firstSlideMessage: t('carousel.firstslidemessage'),
                lastSlideMessage: t('carousel.lastslidemessage'),
                paginationBulletMessage: t('carousel.paginationbulletmessage').replace('INDEX_NUMBER', slides.length),
            } }, options), renderSlides()));
    };
    const imageSwiper = () => {
        const imageSwiperOptions = {
            onSwiper: (swiper) => {
                imageCarouselRef.current = swiper;
            },
            className: 'hero-carousel__slider swiper-wrapper',
            autoplay: false,
            onBeforeResize: () => beforeResize(),
            onResize: () => debounce(() => onResize(), 500),
            onAfterInit: (swiper) => {
                swiper.$el.addClass('initialized');
            },
            onSlideChange: (swiper) => {
                var _a;
                (_a = swiper.el.querySelectorAll('.swiper-slide video')) === null || _a === void 0 ? void 0 : _a.forEach((v) => {
                    v.mute = true;
                    v.setVolume(0);
                });
            },
        };
        return renderSwiper(imageSwiperOptions, imageSlides);
    };
    const imageSlides = () => {
        return slides.map((slide) => {
            var _a;
            return (React.createElement(SwiperSlide, { key: slide.id, className: classNames('hero__hero-column hero-carousel__single-slide swiper-slide text-color--white aspect-ratio--16-9', { 'swiper-slide-active': !isCarousel }), "data-index": slide.id },
                React.createElement("div", { className: classNames('hero-column__inner-container', { 'title--hidden': data.countdown_active }) },
                    React.createElement("span", { className: "hero-column__img" },
                        ((_a = slide.custom.mobileImage) === null || _a === void 0 ? void 0 : _a.src) && (React.createElement("picture", null,
                            React.createElement("source", { media: "(min-width: 1800px)", srcSet: `${slide.custom.imagesSrc['2000w'].src}` }),
                            React.createElement("source", { media: "(min-width: 1600px)", srcSet: `${slide.custom.imagesSrc['1800w'].src}` }),
                            React.createElement("source", { media: "(min-width: 1400px)", srcSet: `${slide.custom.imagesSrc['1600w'].src}` }),
                            React.createElement("source", { media: "(min-width: 1200px)", srcSet: `${slide.custom.imagesSrc['1400w'].src}` }),
                            React.createElement("source", { media: "(min-width: 1024px)", srcSet: `${slide.custom.imagesSrc['1200w'].src}` }),
                            React.createElement("source", { media: "(min-width: 800px)", srcSet: `${slide.custom.imagesSrc['1024w'].src}` }),
                            React.createElement("source", { media: "(min-width: 600px)", srcSet: `${slide.custom.imagesSrc['800w'].src}` }),
                            React.createElement("source", { media: "(min-width: 400px)", srcSet: `${slide.custom.imagesSrc['600w'].src}` }),
                            React.createElement(Lazyimg, { src: slide.custom.mobileImage.src, alt: slide.data.imgAlt || '', className: "hero-carousel-img" }))),
                        slide.data.thronID && React.createElement(ThronVideo, { thronID: slide.data.thronID, thronMobileID: slide.data.thronMobileID, lockBitrate: slide.data.lockBitrate && 'max' })))));
        });
    };
    const contentSwiper = () => {
        const contentSwiperOptions = {
            onSwiper: (swiper) => {
                contentCarouselRef.current = swiper;
            },
            className: 'hero-carousel__slider-content swiper-wrapper',
            modules: [EffectFade, Navigation, Pagination, Autoplay],
            pagination: { el: `.swiper-pagination--${props.uuid}`, clickable: true },
            onSlideChangeTransitionStart: (swiper) => {
                imageCarouselRef.current.slideTo(swiper.activeIndex);
            },
            onAfterInit: (swiper) => {
                swiper.el.closest('.hero-carousel__content-carousel').classList.add('initialized');
                swiper.params.autoplay = { delay: 5800 };
                swiper.autoplay && swiper.autoplay.start();
                swiper.el.closest('.hero-carousel__content-carousel').classList.add('swiper-autoplay');
            },
            onSlideChange: (swiper) => {
                var _a;
                (_a = swiper.el.querySelectorAll('.swiper-slide [data-mute]')) === null || _a === void 0 ? void 0 : _a.forEach((el) => {
                    el.setAttribute('aria-pressed', false);
                    setMute(true);
                });
            },
        };
        return renderSwiper(contentSwiperOptions, contentSlides);
    };
    const contentSlides = () => {
        return slides.map((slide) => {
            var _a;
            return (React.createElement(SwiperSlide, { key: slide.id, className: classNames('swiper-slide', { 'single-slide swiper-slide-active': !isCarousel }), "data-index": slide.data.uuid },
                React.createElement(HeroCarouselContentSlide, { slideData: slide.data, relatedCustomerGroupsCondition: props.relatedCustomerGroupsCondition, lockType: props.lockType, modalImage: (_a = slide.custom.modalImage) === null || _a === void 0 ? void 0 : _a.src, mute: mute, setMute: setMute })));
        });
    };
    let { data } = componentData;
    return (React.createElement(React.Fragment, null,
        data.heroTitle && data.heroTitle.trim().length > 0 && React.createElement("h2", { className: "visually-hidden" }, data.heroTitle),
        React.createElement("section", { className: "hero-carousel__main-wrapper", ref: heroCarouselRef },
            React.createElement("div", { className: classNames('swiper-container', 'hero-carousel__image-carousel', 'hero', `hero--${data.alignmentSimplified.split(' ').join('-').toLowerCase()}`, {
                    'flexible-height': data.flexible,
                }), "aria-roledescription": "carousel", "aria-label": t('title.hero'), "data-option-uuid": `${props.uuid}` }, isCarousel ? imageSwiper() : singleSlideWrapper('image')),
            React.createElement("div", { className: "hero-carousel__content-carousel-wrapper" },
                React.createElement("div", { className: classNames('swiper-container hero-carousel__content-carousel hero', `hero--${data.alignmentSimplified.split(' ').join('-').toLowerCase()}`, `gradient-${data.gradientStrength}`, { 'flexible-height': data.flexible }), "aria-roledescription": "carousel", "aria-label": t('title.hero'), "data-option-uuid": `${props.uuid}-content` },
                    (slides.length > 1 || slides[0].data.thronID) && (React.createElement("button", { className: "btn--pause btn--pause-white", "aria-label": t('button.pause'), "data-pause": true, "aria-pressed": "false", onClick: () => setPause(!pause) })),
                    isCarousel ? contentSwiper() : singleSlideWrapper('content'),
                    slides.length > 1 && React.createElement("div", { className: classNames('swiper-pagination', 'swiper-pagination--bars', `swiper-pagination--${props.uuid}`), "aria-hidden": "true" }))))));
};
export default HeroCarousel;
